import { render, staticRenderFns } from "./PartnerBoxItem.vue?vue&type=template&id=33621d5f&scoped=true&"
import script from "./PartnerBoxItem.vue?vue&type=script&lang=js&"
export * from "./PartnerBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./PartnerBoxItem.vue?vue&type=style&index=0&id=33621d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33621d5f",
  null
  
)

export default component.exports